import React, { useState, useEffect } from 'react';
import '../../css/Home.css';
import HomeBanner from '../../components/HomePages/HomeBanner';
import Introduction from '../../components/HomePages/Introduction';
import CategoryBar from '../../components/HomePages/CategoryBar';
import CourseList from '../../components/HomePages/CourseList';
import { useData } from '../../state/DataContext'; // Import the context hook

function HomePage() {
  const { courseCards, loading, error } = useData(); // Get courses from context
  const [displayedCourses, setDisplayedCourses] = useState([]);
  const [activeCategory, setActiveCategory] = useState('Popular');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (!courseCards) return;

    let coursesToShow = [];

    if (activeCategory === 'Popular') {
      coursesToShow = courseCards;
    } else if (activeCategory === 'Basic') {
      coursesToShow = courseCards.filter((c) => c.courseType === 'basic');
    } else if (activeCategory === 'Advanced') {
      coursesToShow = courseCards.filter((c) => c.courseType === 'advanced');
    }

    if (searchTerm) {
      coursesToShow = coursesToShow.filter((course) =>
        course.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        course.desc.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (activeCategory === 'Popular' && !searchTerm) {
      setDisplayedCourses(coursesToShow.slice(0, 6));
    } else {
      setDisplayedCourses(coursesToShow);
    }
  }, [courseCards, activeCategory, searchTerm]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div>
      <HomeBanner />
      <Introduction />
      <CategoryBar
        activeCategory={activeCategory}
        setActiveCategory={setActiveCategory}
        setSearchTerm={setSearchTerm}
      />
      <CourseList
        courses={displayedCourses}
        activeCategory={activeCategory}
      />
    </div>
  );
}

export default HomePage;